// extracted by mini-css-extract-plugin
export default {"container-overflow":"xpmKd_","containerOverflow":"xpmKd_"};